import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Tooltip } from '@mui/material';
import cn from 'classnames';
import React from 'react';
import styles from './SocialMediaLinks.module.scss';
// import FacebookLogo from '../../public/fb.svg';
// import LinkedInLogo from '../../public/lin.svg';
// import TwitterLogo from '../../public/tw.svg';

import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const SocialMediaLinks = () => {
  return (
    <div className={cn(styles.socialMediaWrapper, 'mx-auto mt-8 font-libre')}>
      <p>Share this article</p>
      <div className={cn(styles.socialMediaLinks)}>
        <Tooltip enterTouchDelay={1} enterDelay={0} title="Copy link">
          <a
            className={styles.clipboard}
            onClick={() => {
              navigator.clipboard.writeText(
                typeof document !== 'undefined' && document.location.toString()
              );
            }}
          >
            <ContentCopyIcon />
          </a>
        </Tooltip>
        <Tooltip enterTouchDelay={1} enterDelay={0} title="Share via email">
          <a
            className={styles.clipboard}
            href={`mailto:Contact?body=${document.location.toString()}`}
          >
            <MailOutlineIcon />
          </a>
        </Tooltip>
        <Tooltip enterTouchDelay={1} enterDelay={0} title="Share via facebook">
          <a
            className="relative"
            href={`https://www.facebook.com/sharer/sharer.php?u=${
              typeof document !== 'undefined' && document.location.toString()
            }`}
            rel="noreferrer noopener nofollow"
            target="_blank"
          >
            <FacebookRoundedIcon />
          </a>
        </Tooltip>
        <Tooltip enterTouchDelay={1} enterDelay={0} title="Share via twitter">
          <a
            href={`http://twitter.com/share?text=&amp;url=${
              typeof document !== 'undefined' && document.location.toString()
            }`}
            target="_blank"
            rel="noreferrer noopener nofollow"
            className="relative"
          >
            <TwitterIcon />
          </a>
        </Tooltip>
        <Tooltip enterTouchDelay={1} enterDelay={0} title="Share via LinkedIn">
          <a
            className="relative"
            href={`http://www.linkedin.com/shareArticle?mini=true&amp;url=${
              typeof document !== 'undefined' && document.location.toString()
            }`}
            rel="noreferrer noopener nofollow"
            target="_blank"
          >
            <LinkedInIcon />
          </a>
        </Tooltip>
      </div>
    </div>
  );
};
export default SocialMediaLinks;
